export default __webpack_public_path__ + "static/media/fpb20200.19bcffa6.png";